<template>
  <v-bottom-navigation
    :input-value="$vuetify.breakpoint.mdAndDown && drawer"
    app
  >

    <v-btn to="/" icon id="homeMenuItem">
      <v-icon color="primary">mdi-home</v-icon>
    </v-btn>
    <v-btn
       v-if="!isCitizen()"
       to="/knowledge-items"
       icon
       id="kdbMenuItem">
      <v-icon color="primary">mdi-lightbulb</v-icon>
    </v-btn>
    <v-btn id="chat" @click="openChat" v-if="$vuetify.breakpoint.mobile && !isCitizen()">
      <v-icon color="primary">mdi-chat-processing</v-icon>
    </v-btn>
<!--    <v-btn to="/faqs" v-if="!isCitizen()">-->
<!--      <v-icon color="primary">mdi-help-circle</v-icon>-->
<!--    </v-btn>-->

    <v-btn
      v-if="!isCitizen()"
      to="/calltome"
      icon
      id="callToMeMenuItem"
    >
      <v-icon color="primary">mdi-phone</v-icon>
    </v-btn>

    <v-btn
      v-if="!isCitizen()"
      to="/approvals"
      icon
      id="suggestionsMenuItem"
    >
      <span class="babge-buttonNavigation--approvals">
        <v-icon color="primary">mdi-playlist-check</v-icon>
        <v-badge
          v-if="total > 0"
          color="red"
          overlap
        >
          <span
            slot="badge"
            v-bind:style="{
              color: 'white',
            }"
          >
          </span>
        </v-badge>
      </span>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>

import { mapGetters, mapState } from 'vuex';
import { NAMED_ROLES } from '@/store/modules/session';

export default {
  props: {
    drawer: Boolean,
  },
  computed: {
    ...mapGetters({
      hasRoles: 'session/hasRole',
    }),
    ...mapState({
      user: ({ session: { session } }) => (session != null ? session.user : null),
      total: ({ tickets: { total } }) => total,
    }),
    NAMED_ROLES() {
      return NAMED_ROLES;
    },
  },
  methods: {
    async approvalsCount() {
      await this.$store.dispatch('tickets/listApprovals', {});
    },
    hasGroupTEST() {
      return this.user.KdGroupMember;
    },
    isCitizen() {
      return this.user.hasIosUser();
    },
    openChat() {
      const hermesOpenButton = document.querySelector('.gibber-messenger-button');

      if (hermesOpenButton) {
        hermesOpenButton.click();
      }
    },
  },
  mounted() {
    this.approvalsCount();
  },
};
</script>

<style lang="scss">
  .v-bottom-navigation {
    transform: none !important;
  }
  .babge-buttonNavigation--approvals {
    position: relative;
  }
  .babge-buttonNavigation--approvals > span {
    position: initial;
  }
  .babge-buttonNavigation--approvals .v-badge__wrapper span {
    color: white;
    width: 11px;
    height: 12px;
    min-width: inherit;
    min-height: inherit;
    position: absolute;
  }
</style>
